import React from "react";
import {useSelector} from "react-redux";

import {Container} from "@pg-design/grid-module";
import {mb} from "@pg-design/helpers-css";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../app/components/breadcrumbs/BreadcrumbsItem";
import {IRPStore} from "../../app/rp_reducer";
import {SiteMapBox} from "../components/SiteMapBox";
import {SiteMapHeading} from "../components/SiteMapHeading";
import {SiteMapLinkList} from "../components/SiteMapLinkList";
import {getSitemapArticleBreadcrumbs} from "./SiteMapArticleCategory";

export const SiteMapArticleCategoryList = () => {
    const breadcrumbs = getSitemapArticleBreadcrumbs();
    const articleCategoriesLinks =
        useSelector((state: IRPStore) => state.siteMap.articleCategories)?.map((category) => ({
            href: rpAppLink.siteMap.article.category({categorySlug: category.slug}),
            text: category.name
        })) || [];

    return (
        <Container>
            <Breadcrumbs homePageUrl={rpAppLink.base()}>
                {breadcrumbs.map((breadcumb, index) => (
                    <BreadcrumbsItem {...breadcumb} key={breadcumb.key} isLinkingToCurrentLocation={breadcrumbs.length - 1 === index} />
                ))}
            </Breadcrumbs>
            <article css={[mb(4)]}>
                <SiteMapHeading>Mapa strony - Artykuły</SiteMapHeading>
                <SiteMapBox>
                    <SiteMapLinkList links={articleCategoriesLinks} />
                </SiteMapBox>
            </article>
        </Container>
    );
};
import React from "react";
import {useSelector} from "react-redux";

import {Container} from "@pg-design/grid-module";
import {mb} from "@pg-design/helpers-css";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../app/components/breadcrumbs/BreadcrumbsItem";
import {IRPStore} from "../../app/rp_reducer";
import {SiteMapBox} from "../components/SiteMapBox";
import {SiteMapHeading} from "../components/SiteMapHeading";
import {SiteMapLinkList} from "../components/SiteMapLinkList";
import {getSitemapArticleBreadcrumbs} from "./SiteMapArticleCategory";

export const SiteMapArticleCategoryList = () => {
    const breadcrumbs = getSitemapArticleBreadcrumbs();
    const articleCategoriesLinks =
        useSelector((state: IRPStore) => state.siteMap.articleCategories)?.map((category) => ({
            href: rpAppLink.siteMap.article.category({categorySlug: category.slug}),
            text: category.name
        })) || [];

    return (
        <Container>
            <Breadcrumbs homePageUrl={rpAppLink.base()}>
                {breadcrumbs.map((breadcumb, index) => (
                    <BreadcrumbsItem {...breadcumb} key={breadcumb.key} isLinkingToCurrentLocation={breadcrumbs.length - 1 === index} />
                ))}
            </Breadcrumbs>
            <article css={[mb(4)]}>
                <SiteMapHeading>Mapa strony - Artykuły</SiteMapHeading>
                <SiteMapBox>
                    <SiteMapLinkList links={articleCategoriesLinks} />
                </SiteMapBox>
            </article>
        </Container>
    );
};
